import { Link } from "react-router-dom";
import { PHOTOS_URL } from "../../../constants";

function HomeMiddleBanners({ component: Component, ...props }: any) {
  return (
    <div className="middleBannerHome">
      <Link to={props.link}>
        <div className="innerPhoto">
          <img
            src={`https://resizing.cocunat.com/r/?fit=contain&image=${PHOTOS_URL}${props.img}&quality=95`}
            alt={props.img}
          />
        </div>
        <div className="innerText">
          <p className="title">
            {props.title}
            <img
              src={`${PHOTOS_URL}Back.png`}
              alt="arrow"
              style={{
                float: "right",
                position: "absolute",
                top: -5,
                right: 0,
              }}
            />
          </p>
          <p dangerouslySetInnerHTML={{ __html: props.text }} />
        </div>
      </Link>
    </div>
  );
}
export default HomeMiddleBanners;
